import React, { useState, useEffect } from 'react';
import { FiFileText } from "react-icons/fi";
import { LuActivity, LuBone, LuBrain } from "react-icons/lu";
import './NewAssessment.css'
import { APIURL } from "../../../Global";
import axios from "axios";
import Scandinavian from './Scandinavian';
import Asia from './Asia';
import Glasgow from './Glasgow';
const NewScoring = ({ data, refresh }) => {
    const [activeTab, setActiveTab] = useState('');
    const [allow, setAllow] = useState(false)
    const tabs = [
        { id: 'scandinavian', label: 'Scandinavian Stroke Scale', icon: LuActivity },
        { id: 'asia', label: 'ASIA', icon: LuBrain },
        { id: 'glasgow', label: 'Glasgow', icon: LuBone }
    ];

    useEffect(() => {
        fetchAssessments();
    }, [refresh]);

    const fetchAssessments = async () => {
        try {
            const tokenString = sessionStorage.getItem("usertoken");
            let v2 = tokenString.replace(/["]+/g, "");

            const response = await axios.get(`${APIURL}/api/v1/patient/therapy-assessment/?patient_id=${data.id}&assessment_form=neuro`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Token " + v2,
                },
            });

            if (response.data.status === 'success') {
                const newAssessments = response.data.message.slice().reverse();
                if (newAssessments.length > 0 && data.therapy_id === newAssessments[0].therapy_consultation) {
                    setAllow(true);
                }
            } else {
                alert.error(response.data.message || 'Error Occured')
            }
        } catch (err) {
            console.error('Error fetching assessments:', err);
        } finally {
        }
    };

    return (
        <div className="assessment-section">
            <div className="section-header">
                <h2>Score Scale</h2>
            </div>
            <div className="tab-navigation">
                {tabs.map(tab => (
                    <button
                        key={tab.id}
                        className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
                        disabled={!allow}
                        onClick={() => { if (allow) setActiveTab(prev => prev === tab.id ? '' : tab.id) }}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {activeTab === 'scandinavian' ? <Scandinavian data={data} /> : activeTab === 'asia' ? <Asia data={data} /> : activeTab === 'glasgow' ? <Glasgow data={data} /> : null}
        </div>
    );
};

export default NewScoring;